@if (loading.main) {
<div class="d-flex justify-content-center align-items-center mt-5">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>
} @else {
<breadcrumb [items]="breadcrumb" />
<h1 class="mb-0">{{ title }}</h1>
<hr class="mt-2" />
<div class="row">
    <div class="col-12 col-md-6 mb-3">
        <label for="verVersion">Versão</label>
        <input type="text" class="form-control" id="verVersion" name="verVersion" [(ngModel)]="version.version" [disabled]="isEditing" required />
    </div>
    <div class="col-12 col-md-6 mb-3" accessControl="ARIEL_ADMIN">
        <label for="doctorAtivoSwitch" class="form-label">Está depreciada?</label>
        <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="doctorAtivoSwitch" [(ngModel)]="version.isDeprecated" /> 
            <label class="form-check-label" for="doctorAtivoSwitch">
                {{ version.isDeprecated ? "Sim" : "Não" }}
            </label>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-12 col-md-2 offset-md-8 order-2 order-md-1">
        <button class="btn btn-light w-100" [routerLink]="['/configurations']">
            Voltar
        </button>
    </div>
    <div class="col-12 col-md-2 mb-2 mb-md-0 order-1 order-md-2">
        <button class="btn btn-success w-100"  (click)="saveVersion()" [disabled]="!version.version || loading.save"  >
            <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.save"></div>
            <span *ngIf="!loading.save">Salvar</span>
        </button>
    </div>
</div>
}
